export default __webpack_public_path__ + "img/TourStep11-050fc0eb8462986cf5f77aca31f2a6a0.png";